import React from 'react';

import { Alert, Text } from '@change/ds-core-ui';

import { parseHtml } from '@change-corgi/core-react/html';

import { createAnchorToLinkReplacer } from '#src/shared/ds';

import { usePageBanner } from './hooks/usePageBanner';

export const PageBanner: React.FC<EmptyProps> = () => {
	const {
		data: { message, guestMessage },
		actions: { trackGuestMessageLinkClick },
	} = usePageBanner();

	if (!message && !guestMessage) return null;

	return (
		<>
			{message && (
				<Alert type="page" variant="success" data-qa="message-banner">
					{message}
				</Alert>
			)}

			{guestMessage && (
				<Alert type="page" variant="info" data-qa="guest-banner">
					<Text data-qa="guest-message-banner">
						{parseHtml(guestMessage, {
							replace: createAnchorToLinkReplacer({ onClick: () => trackGuestMessageLinkClick() }),
						})}
					</Text>
				</Alert>
			)}
		</>
	);
};
